import React, { useMemo } from "react";
import { Modal, Button, Form } from "react-bootstrap";


const AddEditWebsite = ({show ,handleClose, addEditDialogData , formData , setFormData , handleSubmit}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  console.log(addEditDialogData, formData)

  };

   const isAddMode = addEditDialogData?.callingFor?.toLowerCase() === "Add";
  
    const isButtonDisabled = useMemo(() => {
      const isBankNameEmpty = !formData.websiteName?.trim();
  
      if (isAddMode) return isBankNameEmpty;
  
      // EDIT MODE: check if any field has changed
      const fieldsToCompare = [
        "websiteName",
      ];
  
      const hasChanged = fieldsToCompare.some((field) => {
        const original = addEditDialogData?.data?.[field]?.trim() || "";
        const current = formData?.[field]?.trim() || "";
        return original !== current;
      });
  
      return isBankNameEmpty || !hasChanged;
    }, [formData, addEditDialogData, isAddMode]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{addEditDialogData.dialogTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="d-flex flex-column gap-2" onSubmit={handleSubmit}>
          <Form.Control
            type="text"
            placeholder="Name of Website *"
            name="websiteName"
            value={formData.websiteName}
            onChange={handleInputChange}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button style={{backgroundColor:'#4682b4'}} onClick={handleSubmit} disabled={isButtonDisabled}>
            {addEditDialogData?.callingFor} Website
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(AddEditWebsite);